import { render } from "./KitchenDisplayTable.vue?vue&type=template&id=246df51a"
import script from "./KitchenDisplayTable.vue?vue&type=script&lang=js"
export * from "./KitchenDisplayTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__